export interface IMailchimpAudienceMergeFields {
	FNAME?: string;
	LNAME?: string;
	CITY?: string;
	STATE_PROV?: string;
	COUNTRY?: string;
	USERID?: string;
	CREATED_AT?: string;
	MEM_SINCE?: string;
	SUB_CANCEL?: string;
	ROLE?: "guest" | "user";
	SUB_TYPE?: string;
	PROFESSION?: string;
	CERT?: string;
	IS_TRIAL?: string;
	TRIAL_DAYS?: string;
	NINETY_ANN?: string;
	YEAR_ANN?: string;
	WORK_ATTN?: string;
	WORK_DATE?: string;
	SIGNUP_LOC?: string;
}

export interface MailchimpTrigger {
	journey_id: number;
	step_id: number;
}

export const journeyTriggerMap: Record<string, MailchimpTrigger> = {
	chiropractors: { journey_id: 2918, step_id: 30430 },
	"certified-athletic-trainers": { journey_id: 3146, step_id: 30414 },
	"occupational-therapists": { journey_id: 3150, step_id: 30418 },
	"PT-PTA-CE": { journey_id: 2882, step_id: 30426 },
	"licensed-massage-therapists": { journey_id: 2878, step_id: 30422 },
	"integrated-manual-therapist": { journey_id: 2750, step_id: 30434 },
	"human-movement-specialist": { journey_id: 2702, step_id: 30438 },
	"certified-personal-trainers": { journey_id: 2686, step_id: 30442 },

	"trial-membership": { journey_id: 3042, step_id: 30530 },

	// CPT
	"certification-selected-3f4be808-aa5b-4ee7-bda0-095723363f07": {
		journey_id: 2990,
		step_id: 30542,
	},
	"certification-selected-a1c5c26d-69a1-4e10-9997-35c5e67aa75d": {
		journey_id: 2990,
		step_id: 30542,
	},

	// HMS
	"certification-selected-322f8cd3-148e-4e1f-ab7f-91d77d4ddac5": {
		journey_id: 2994,
		step_id: 30538,
	},
	"certification-selected-ceaac7a0-c802-45ee-ab83-e9d7eaa4b0e3": {
		journey_id: 2994,
		step_id: 30538,
	},

	// IMT
	"certification-selected-475adddd-b707-4373-aede-574a003649ec": {
		journey_id: 2998,
		step_id: 30534,
	},
	"certification-selected-e093aaf7-e951-42a9-ad1d-6d6c462e8407": {
		journey_id: 2998,
		step_id: 30534,
	},
	"certification-selected-20605d3a-9b31-4a52-b1e7-52a2c091764a": {
		journey_id: 2998,
		step_id: 30534,
	},
};
